module.exports = __webpack_public_path__ + "img/setting.6a06510c.svg";